import React, { useEffect, useRef, useState, useMemo, useCallback } from 'react'
import ReactPlayer from 'react-player'
import Slider from 'react-slick'
import playImg from '../../../Assets/images/play.svg'
import noVideoImg from '../../../Assets/images/no-video.svg'
import { useNavigate } from 'react-router-dom'
const DigitalPortfolio = ({ kidId, data }) => {
  const navigate = useNavigate()
  const contentDivRef = useRef(null)
  const thumbSettings = useMemo(
    () => ({
      slidesToShow: 3,
      slidesToScroll: 1,
      swipeToSlide: true,
      arrows: true,
      centerMode: true,
      centerPadding: '20px',
      focusOnSelect: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            swipeToSlide: true,
            arrows: false,
            centerMode: true,
            centerPadding: '20px',
            focusOnSelect: true,
            verticalSwiping: true,
          },
        },
      ],
    }),
    [],
  )

  const VideoBox = useCallback(({ url, isPlaying, isLoading, videoError, setIsPlaying, setIsLoading, setVideoError }) => {
    if (videoError) {
      return (
        <div className="is-not-video inter">
          <img src={noVideoImg} alt="Video error" />
          Failed to load video
        </div>
      )
    }

    if (url) {
      return (
        <div className="video-player-wrapper col-md-7">
          <ReactPlayer
            key={url}
            url={url}
            controls={true}
            height={'100%'}
            width={'100%'}
            className="summary-video"
            playing={isPlaying}
            onReady={() => setIsLoading(false)}
            onBuffer={() => setIsLoading(true)}
            onBufferEnd={() => setIsLoading(false)}
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
            onEnded={() => setIsPlaying(false)}
            onError={(e) => {
              setVideoError(e)
              setIsLoading(false)
            }}
            config={{
              file: {
                attributes: {
                  preload: 'metadata',
                },
              },
            }}
          />
        </div>
      )
    }
    return (
      <div className="is-not-video inter">
        <img src={noVideoImg} alt="No video" />
        No Video to display
      </div>
    )
  }, [])

  const ThumbnailPreview = useCallback(({ url, thumbnailUrl, isActive }) => {
    if (url) {
      return (
        <div className={`videothumbnail ${isActive ? 'active' : ''}`}>
          <img src={playImg} className="play-icon" alt="Play" />
          <img src={thumbnailUrl || 'https://storage.googleapis.com/kidex-thumbnails-in/feeds/1c426beb-729a-45dd-9c5b-2bfd9ff4cefe1722867327022.jpg'} className="h-100" alt="Video thumbnail" />
        </div>
      )
    }
    return (
      <div className="videothumbnail">
        <img src={noVideoImg} alt="No video" />
      </div>
    )
  }, [])

  const VideoSection = ({ title, skillData }) => {
    const videoUrls = useMemo(() => {
      const urls = []
      if (skillData && Array.isArray(skillData)) {
        skillData.forEach((skill) => {
          if (skill?.activity_File_url) {
            urls.push(skill.activity_File_url)
          }
        })
      }
      return urls
    }, [skillData])

    const thumbnailUrls = useMemo(() => {
      const urls = []
      if (skillData && Array.isArray(skillData)) {
        skillData.forEach((skill) => {
          if (skill?.activity_snapshot_url) {
            urls.push(skill.activity_snapshot_url)
          }
        })
      }
      return urls
    }, [skillData])

    const thumbnailTitles = useMemo(() => {
      const titles = []
      if (skillData && Array.isArray(skillData)) {
        skillData.forEach((skill) => {
          if (skill?.activity_name) {
            titles.push(skill.activity_name)
          }
        })
      }
      return titles
    }, [skillData])

    const [currentVideoUrl, setCurrentVideoUrl] = useState(videoUrls[0])
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0)
    const [isPlaying, setIsPlaying] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [videoError, setVideoError] = useState(null)

    useEffect(() => {
      setCurrentVideoUrl(videoUrls[0])
      setCurrentVideoIndex(0)
    }, [videoUrls])

    const handleThumbnailClick = useCallback(
      (index) => {
        setIsPlaying(false)
        setVideoError(null)
        setCurrentVideoUrl(videoUrls[index])
        setCurrentVideoIndex(index)
        setIsLoading(true)
        setTimeout(() => {
          setIsPlaying(true)
        }, 100)
      },
      [videoUrls],
    )

    const thumbnailElements = useMemo(
      () =>
        videoUrls.map((url, index) => (
          <div key={index} onClick={() => handleThumbnailClick(index)} style={{ cursor: 'pointer' }}>
            <ThumbnailPreview url={url} thumbnailUrl={thumbnailUrls[index]} isActive={currentVideoIndex === index} />
            <h3 className="thumbnail-title">{thumbnailTitles[index]}</h3>
          </div>
        )),
      [videoUrls, thumbnailUrls, currentVideoIndex, handleThumbnailClick, thumbnailTitles],
    )

    if (videoUrls.length === 0) {
      return null
    }

    return (
      <div className="mb-5 pb-3">
        <div className="d-flex justify-content-between align-items-center my-3">
          <h2 className="title-18 title-16">{title}</h2>
          <button
            className="acc-edit-icon d-flex justify-content-center border-0 bg-transparent"
            onClick={() => (title == 'Introduction' ? navigate('/profile', { state: { step: 2 } }) : title == 'Basic Skills' ? navigate('/screening-criteria') : '')}
          >
            <img src="./svg/edit-blue.svg" />
            edit
          </button>
        </div>
        <div className="digital-portfolio-videos">
          <VideoBox url={currentVideoUrl} isPlaying={isPlaying} isLoading={isLoading} videoError={videoError} setIsPlaying={setIsPlaying} setIsLoading={setIsLoading} setVideoError={setVideoError} />
        </div>
        {title != 'Introduction' && (
          <Slider {...thumbSettings} className="thumbnail-slider mt-3">
            {thumbnailElements}
          </Slider>
        )}
      </div>
    )
  }

  return (
    <div ref={contentDivRef}>
      {/* Introduction Details Section */}
      {data?.introduction_details?.length > 0 ? (
        <VideoSection title="Introduction" skillData={data?.introduction_details} />
      ) : (
        <>
          <div className="d-flex justify-content-between ">
            <h2 className="title-18 title-16">Introduction</h2>
            <button className="acc-edit-icon d-flex justify-content-center border-0 bg-transparent" onClick={() => navigate('/profile', { state: { step: 2 } })}>
              <img src="./svg/edit-blue.svg" />
              edit
            </button>
          </div>
          <div className="text-center offset-md-3 col-md-6 bg-no-content-data mb-5 p-4">
            <div>
              <h3 className="no-data-title">No Uploads yet</h3>
              <span style={{ fontSize: '12px' }}>Add your video now to boost visibility and improve your chances of landing a job.</span>
            </div>
            <img src={`images/empty-data-vector.svg`} alt="no data img" className="" />
          </div>
        </>
      )}

      {/* Basic Skills Section */}
      {data?.basic_skills?.length > 0 ? (
        <VideoSection title="Basic Skills" skillData={data?.basic_skills} />
      ) : (
        <>
          <div className="d-flex justify-content-between ">
            <h2 className="title-18 title-16">Basic Skills</h2>
            <button className="acc-edit-icon d-flex justify-content-center border-0 bg-transparent" onClick={() => navigate('/screening-criteria')}>
              <img src="./svg/edit-blue.svg" />
              edit
            </button>
          </div>
          <div className="text-center offset-md-3 col-md-6 bg-no-content-data mb-5 p-4">
            <div>
              <h3 className="no-data-title">No Uploads yet</h3>
              <span style={{ fontSize: '12px' }}>Add your video now to boost visibility and improve your chances of landing a job.</span>
            </div>
            <img src={`images/empty-data-vector.svg`} alt="no data img" className="" />
          </div>
        </>
      )}

      {/* Advanced Skills Section */}
      {data?.advanced_skills?.length > 0 ? (
        <VideoSection title="Advanced Skills" skillData={data?.advanced_skills} />
      ) : (
        <>
          <div className="d-flex justify-content-between ">
            <h2 className="title-18 title-16">Advanced Skills</h2>
            <button className="acc-edit-icon d-flex justify-content-center border-0 bg-transparent" onClick={() => navigate('/screening-criteria')}>
              <img src="./svg/edit-blue.svg" />
              edit
            </button>
          </div>
          <div className="text-center offset-md-3 col-md-6 bg-no-content-data mb-5 p-4">
            <div>
              <h3 className="no-data-title">No Uploads yet</h3>
              <span style={{ fontSize: '12px' }}>Add your video now to boost visibility and improve your chances of landing a job.</span>
            </div>
            <img src={`images/empty-data-vector.svg`} alt="no data img" className="" />
          </div>
        </>
      )}
    </div>
  )
}

export default DigitalPortfolio
